import { Button } from "primereact/button";

const LibraryContent = ({ searchFilterSectionVisibility, exercises, addedExercises, handleAdd, setExerciseVideoDialogVisible, setSelectedExercise, handleExerciseDelete, handleFavorite, t }: any) => {
    const playVideo = (exercise: any) => {
        setExerciseVideoDialogVisible(true);
        setSelectedExercise(exercise);
    }

    const template = (exercise: any, index:number) => {
        const includeInSelectedExercises = addedExercises?.some((selected:any) => selected?.id === exercise?.id)
        const circleImageSrc = includeInSelectedExercises ? "/exerciseCircleIconOnHover.png" : "/exerciseCircleIcon.png";
        const isExerciseFavorite = exercise?.isFavorite;

        return (
            <div
                key={exercise?.id}
                className="product-card"
            >
                <div
                    className={`flex h-12rem pl-3 justify-content-between gap-2 ${includeInSelectedExercises && "clickable-data-div"}`}
                        style={{
                        backgroundColor: "#F5F5F5",
                        borderRadius: "18px",
                        position: "relative",
                        transition: "background-color 0.8s ease",
                    }}
                >
                    <div className="flex flex-column justify-content-between pt-3 pb-3">
                        <p className="text-sm font-bold" style={{ color: "#2D3967" }}>{exercise.name}</p>
                        <div className="flex align-items-center gap-2">
                            {!includeInSelectedExercises && <Button id={`add-button-${index}`} onClick={(e) => handleAdd(exercise,index,e)} icon="pi pi-plus" style={{width: '2.25rem', height: '2.25rem', backgroundColor: "#6383F4", border: "none", borderRadius: "15px"}} />}
                            {includeInSelectedExercises && <Button onClick={() => handleExerciseDelete(exercise)} icon="pi pi-minus" style={{width: '2.25rem', height: '2.25rem', backgroundColor: "#6383F4", border: "none", borderRadius: "15px"}} />}
                            <Button onClick={() => handleFavorite(exercise, isExerciseFavorite ? "remove" : "add")} icon="pi pi-heart" style={{width: '2.25rem', height: '2.25rem', backgroundColor: isExerciseFavorite ? "#E3506B" : "#FCEEF0", color: isExerciseFavorite ? "#FFFFFF" : "#E3506B", border: "none", borderRadius: "15px"}} />
                            <Button onClick={() => playVideo(exercise)} className="flex justify-content-center align-items-center" style={{width: '2.25rem', height: '2.25rem', backgroundColor: "#E3506B", border: "none", borderRadius: "15px"}}>
                                <img src="/playIcon.svg" width={20} height={20} />
                            </Button>
                        </div>
                    </div>
                    <img src={exercise?.image} style={{ objectFit: "contain", width: "40%", zIndex: 2 }} className="exercise-img"/>
                    <img
                        src={circleImageSrc}
                        style={{
                            objectFit: "contain",
                            width: "60%",
                            position: "absolute",
                            top: "50%",
                            left: "70%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 1
                        }}
                    />
                </div>
            </div>
        )
    }

    return (
        <div className={`flex flex-wrap ${searchFilterSectionVisibility ? "justify-content-start" : "justify-content-center"} gap-3`}>
            {exercises?.map((exercise: any, index: number) => (
                <div key={index} className="w-20rem">
                    {template(exercise, index)}
                </div>
            ))}
        </div>
    )
}

export default LibraryContent;